import React, { useRef, useState } from "react";
import { CheckIcon } from "/src/helpers/components/upsellIcons.jsx";

// Transient "added to basket" toast (prototype checkout.jsx Toast) — green pill, bottom-centre.
export function useToast() {
    const [message, setMessage] = useState(null);
    const timer = useRef(null);
    const flash = (msg) => {
        setMessage(msg);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setMessage(null), 2600);
    };
    return { toast: message, flash };
}

export default function Toast({ message }) {
    if (!message) return null;
    return (
        <div className="fixed left-1/2 bottom-7 -translate-x-1/2 z-50 bg-green text-white px-5 py-3 rounded-xl
                        shadow-[0_10px_30px_rgba(31,158,110,0.4)] text-sm font-semibold flex items-center gap-2.5">
            <CheckIcon size={18} strokeWidth={2.4} />
            {message}
        </div>
    );
}
